/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { COLORS } from "./footer.constants";

export default function FooterContact() {
  const { t } = useTranslation();

  return (
    <div className="col-12 col-md-4 mb-4 d-flex flex-column align-items-center align-items-md-end">
      <h5
        className="fw-bold mb-3"
        style={{
          color: COLORS.gold,
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {t("footer.contactTitle")}
      </h5>

      <p
        className="mb-2"
        style={{
          color: COLORS.textLight,
          fontSize: "1rem",
          opacity: 0.9,
        }}
      >
        {t("footer.location")}
      </p>

      <p className="mb-3" id="support-email">
        <a
          href="mailto:support@madar.com"
          style={{
            color: COLORS.gold,
            textDecoration: "none",
            fontWeight: "600",
          }}
        >
          {t("footer.email")}
        </a>
      </p>
    </div>
  );
}
